import { useQuery } from "@tanstack/react-query";
import { authClient } from "@/lib/auth";
import { listCelebrities } from "../api";

/**
 * Server-backed celebrity roster. Refetched on an interval long enough that
 * admin edits propagate without hammering the API. Celebrity mode is behind
 * the sign-in wall, so the list only loads for authenticated users.
 */
export function useCelebrities() {
  const { data: session } = authClient.useSession();
  return useQuery({
    queryKey: ["celebrities"],
    queryFn: listCelebrities,
    staleTime: 60_000,
    refetchInterval: 300_000,
    enabled: Boolean(session?.session),
  });
}
